export default {
  PROJECTS: {
    NAME: {
      REQUIRED: 'Please type a name for the project',
      // TODO: Make maxLength limit more dynamic
      MAX_LENGTH: 'Please use maximum 96 chars',
      REGEX:
        'Project names must start with a letter and consist only of letters, digits, dashes or undescores',
      EXISTS: 'This project already exists',
    },
    ACCOUNT: 'Please select an organization',
    FILE: 'Please select a .nlu file to import',
    ALLOWED_NUMBER_OF_FILES: 'Please select only 1 .nlu file to import',
    CLONED_PROJECT: 'Please select a project to clone',
    FLOW_2: {
      ALERT_TITLE: 'FLOW 2 BETA WARNING',
      ALERT_DESCRIPTION:
        "Flow 2 is still under development. Some features like project cloning, snapshots or version-control will not be available. Please see the Flow2 user guide for more. You can't use both templates and flow 2 due to compatibility issues.",
    },
  },
  ENVIRONMENTS: {
    NAME: {
      REQUIRED: 'Please type a name for the environment',
    },
    DASHBOARD_URL: {
      REQUIRED: 'Please type a URL',
      REGEX: 'Please type a valid URL',
    },
    EMAIL_OR_USERNAME: {
      REQUIRED: 'Please type a username or an email',
    },
    DEPLOYMENT_ENVIRONMENT: {
      REQUIRED: 'Please select a deployment environment',
    },
    DASHBOARD_PASSWORD: {
      REQUIRED: 'Please type a password',
    },
    PASSWORD: {
      REQUIRED: 'Please type a password',
      MIN_LEN: 'Password must be at least 5 characters long',
    },
  },
  ENTITIES: {
    NAME: {
      REGEX:
        'Entities names must start with a letter and consist only of letters, digits, or underscores',
      MAX_LENGTH: 'Please use maximum 96 chars',
      EXISTS: 'This entity already exists',
      RESERVED: 'This entity name is reserved by xPack functionality',
    },
  },
  FEATURES: {
    NAME: {
      REQUIRED: 'Feature names cannot be empty',
      REGEX:
        'Feature names must start with a letter and consist only of letters, digits, or underscores',
      UNIQUE: 'Feature names must be unique',
    },
    TYPE: 'Feature types cannot be empty',
  },
  CONTEXTS: {
    NAME: {
      REGEX:
        'Contexts names must start with a letter and consist only of letters, digits, or underscores',
      MAX_LENGTH: 'Please use maximum 96 chars',
      EXISTS: 'This context already exists',
    },
  },
  INTENTS: {
    NAME: {
      REGEX: {
        CREATE:
          'Intents names must start with a letter and consist only of letters, digits, dots or underscores',
        UPDATE:
          'Intents names must start with a letter and consist only of letters, digits, and the following symbols: - . _ ',
      },
      MAX_LENGTH: 'Please use maximum 96 chars',
      EXISTS: 'This intent already exists',
    },
    ENTITY: {
      REQUIRED: 'Entity cannot be empty',
    },
    OPERATOR: {
      REQUIRED: 'Operator cannot be empty',
    },
    REFERENCE: {
      REQUIRED: 'Reference cannot be empty',
    },
  },
  DICTIONARIES: {
    NAME: {
      REGEX:
        'Dictionaries names must start with a letter and consist only of letters, digits, or underscores',
      MAX_LENGTH: 'Please use maximum 96 chars',
      EXISTS: 'This dictionary already exists',
    },
  },
  RULES: {
    NAME: {
      REGEX: {
        CREATE:
          'Context Rules names must start with a letter and consist only of letters, digits, or underscores',
        UPDATE:
          'Context Rules names must start with a letter and consist only of letters, digits and the following symbols: - . _ < > [ ]',
      },
      MAX_LENGTH: 'Please use maximum 96 chars',
      EXISTS: 'This rule already exists',
    },
    ORDER: 'Enter a valid order',
    CONDITIONS: {
      ENTITY_COND: {
        ENTITY: {
          REQUIRED: 'Entity cannot be empty',
        },
        MATCHING_PATTERN: {
          REQUIRED: 'Entity cannot be empty',
        },
        OPERATOR: {
          REQUIRED: 'Operator cannot be empty',
        },
      },
      REGEX_COND: {
        MATCHING_PATTERN: {
          REQUIRED: 'Entity cannot be empty',
        },
        REGEX: {
          REQUIRED: 'Regular expression cannot be empty',
        },
      },
      FEATURE_COND: {
        MATCHING_PATTERN: {
          REQUIRED: 'Entity cannot be empty',
        },
        FEATURE: {
          REQUIRED: 'Feature cannot be empty',
        },
        VALUES: {
          REQUIRED: 'values cannot be empty',
        },
      },
    },
    ACTIONS: {
      MARK: {
        ENTITY: {
          REQUIRED: 'Entity cannot be empty',
        },
        MATCHING_PATTERN_ELEMENT_FROM: {
          REQUIRED: '"From" cannot be empty when "To" has value',
        },
        MATCHING_PATTERN_ELEMENT_TO: {
          REQUIRED: '"To" cannot be empty when "From" has value',
        },
        EXPLICIT: {
          REQUIRED: 'Value cannot be empty',
        },
        DYNAMIC: {
          MATCHING_PATTERN: {
            REQUIRED: 'Entity cannot be empty',
          },
          FEATURE: {
            REQUIRED: 'Feature cannot be empty',
          },
        },
        CONCATENATION: {
          MATCHING_PATTERN: {
            REQUIRED: 'Entity cannot be empty',
          },
          FEATURE: {
            REQUIRED: 'Feature cannot be empty',
          },
        },
      },
      FILL: {
        ENTITY: {
          REQUIRED: 'Entity cannot be empty',
        },
        EXPLICIT: {
          REQUIRED: 'Value cannot be empty',
        },
        DYNAMIC: {
          MATCHING_PATTERN: {
            REQUIRED: 'Entity cannot be empty',
          },
          FEATURE: {
            REQUIRED: 'Feature cannot be empty',
          },
        },
        CONCATENATION: {
          MATCHING_PATTERN: {
            REQUIRED: 'Entity cannot be empty',
          },
          FEATURE: {
            REQUIRED: 'Feature cannot be empty',
          },
        },
        VALUE_TYPE: {
          REQUIRED: 'At least one feature is required',
        },
      },
      UNMARK: {
        MATCHING_PATTERN: {
          REQUIRED: 'Entity cannot be empty',
        },
      },
      SHIFT: {
        MATCHING_PATTERN: {
          REQUIRED: 'Entity cannot be empty',
        },
        MATCHING_PATTERN_FROM: {
          REQUIRED: 'From cannot be empty',
        },
        MATCHING_PATTERN_TO: {
          REQUIRED: 'To cannot be empty',
          VALUE: 'To cannot be less than from',
        },
      },
    },
  },
  RULE_GROUPS: {
    NAME: {
      REGEX:
        'Rule groups names must start with a letter and consist only of letters, digits, or underscores',
      MAX_LENGTH: 'Please use maximum 96 chars',
      EXISTS: 'This rule group already exists',
    },
    ORDER: 'Enter a valid order',
  },
  RESET_PASSWORD: {
    PASSWORD: {
      REQUIRED: 'Enter your new password',
      NUMERIC: 'Do not enter only numbers',
      MIN_LEN: 'Enter at least 8 chars',
      PLACEHOLDER: 'Enter new password',
    },
    CONFIRM_PASSWORD: {
      REQUIRED: 'Re-enter your new password',
      PLACEHOLDER: 'Confirm password',
    },
    MATCH: 'Passwords do not match',
  },
  FORGOT_PASSWORD: {
    EMAIL: {
      REQUIRED: 'Enter your email',
      VALID: 'Enter a valid email',
      PLACEHOLDER: 'name@omilia.com',
    },
  },
  LOGIN: {
    EMAIL: {
      REQUIRED: 'Enter your email',
      VALID: 'Enter a valid email',
      PLACEHOLDER: 'name@omilia.com',
    },
    PASSWORD: {
      REQUIRED: 'Enter your password',
      PLACEHOLDER: 'Enter your password',
    },
  },
  NEW_FLOW: {
    APPSETUP: {
      GENERAL: {
        INFORMATION: {
          TITLE: {
            REQUIRED: 'Name cannot be empty',
            REGEX: 'Name should consist of letters, underscores and dashes',
          },
          VERSION: {
            REQUIRED: 'Version cannot be empty',
            REGEX: 'Version should be in the form of X.Y.Z',
          },
          ANALYZERS: {
            RANGE: 'Value must be between 1 and 7',
          },
          CUSTOM_MODULE: {
            REQUIRED:
              'Either none or both fields of the custom module should be set',
          },
          LOCALE: {
            REQUIRED: 'Locale cannot be empty',
          },
        },
        PROPERTIES: {
          FETCH_TARGETS: {
            FAILED: 'Error fetching Targets.',
          },
          MAX_NBEST: {
            VALID: 'Max N-Best should be a positive integer',
          },
          TIMEOUT: {
            VALID: 'Timeout should be greater than 0',
          },
        },
      },
      ENTITIES_FIELDS: {
        FIELD: {
          NAME: {
            REQUIRED: 'Name cannot be empty',
            REGEX: 'Name must consist only of letters and underscores',
            EXISTS: 'This field already exists',
          },
          CATEGORY: {
            REQUIRED: 'Please select a field type',
          },
        },
        CREATE_FIELD: {
          SUCCESSFUL: 'Field created successfully!',
          FAILED: 'Error creating Field',
        },
        CREATE_MESSAGE: {
          SUCCESSFUL: 'Message created successfully!',
          FAILED: 'Error creating Message',
        },
        UPDATE_FIELD: {
          SUCCESSFUL: 'Field updated successfully!',
          FAILED: 'Error updating Field',
        },
        UPDATE_MESSAGE: {
          SUCCESSFUL: 'Message updated successfully!',
          FAILED: 'Error updating Message',
        },
        DELETE_FIELD: {
          SUCCESSFUL: 'Field deleted successfully!',
          FAILED: 'Error deleting Field',
        },
        DELETE_MESSAGE: {
          SUCCESSFUL: 'Message deleted successfully!',
          FAILED: 'Error deleting Message',
        },
        FETCH_FIELDS: {
          FAILED: 'Error fetching Fields',
        },
        FETCH_FIELD: {
          FAILED: 'Error fetching Field',
        },
      },
      VALIDATIONS_AND_INFERENCES: {
        INFERENCES: {
          NAME: {
            REQUIRED: 'Name cannot be empty',
            REGEX: 'Name must consist only of letters and underscores',
            EXISTS: 'This inference already exists',
          },
          FIELD: {
            REQUIRED: 'Field cannot be empty',
          },
          CREATE_INFERENCE: {
            SUCCESS: 'Inference created successfully!',
            FAILED: 'Error creating Inference',
          },
          UPDATE_INFERENCE: {
            SUCCESS: 'Inference updated successfully!',
            FAILED: 'Error updating Inference',
          },
          DELETE_INFERENCE: {
            SUCCESS: 'Inference deleted successfully!',
            FAILED: 'Error deleting Inference',
          },
          FETCH_INFERENCES: {
            FAILED: 'Error fetching Inferences',
          },
        },
        VALIDATIONS: {
          NAME: {
            REQUIRED: 'Name cannot be empty',
            REGEX: 'Name must consist only of letters and underscores',
            EXISTS: 'This validation already exists',
          },
          FIELD: {
            REQUIRED: 'Field cannot be empty',
          },
          CREATE_VALIDATION: {
            SUCCESS: 'Validation created successfully!',
            FAILED: 'Error creating Validation',
          },
          UPDATE_VALIDATION: {
            SUCCESS: 'Validation updated successfully!',
            FAILED: 'Error updating Validation',
          },
          DELETE_VALIDATION: {
            SUCCESS: 'Validation deleted successfully!',
            FAILED: 'Error deleting Validation',
          },
          FETCH_VALIDATIONS: {
            FAILED: 'Error fetching Validations',
          },
        },
      },
      NLG_REALIZERS: {
        REALIZER: {
          NAME: {
            REQUIRED: 'Name cannot be empty',
            REGEX: 'Name must consist only of letters and underscores',
            EXISTS: 'This realizer already exists',
          },
          MODES: {
            NAME: {
              REQUIRED: 'Name cannot be empty',
              REGEX: 'Name must consist only of letters and digits',
              LENGTH: 'Ensure this field has exactly 4 digits alphanumeric',
              EXISTS: 'This name already exists',
            },
            RESPONSE_TYPE: {
              REQUIRED: 'This field is required',
            },
            ASSOCIATIONS: {
              VALUE: {
                REQUIRED: 'This field may not be blank',
                EXISTS: 'This value already exists',
              },
            },
          },
          LABEL: {
            REQUIRED: 'Please select a realizer type',
          },
          CREATE_REALIZER: {
            SUCCESSFUL: 'Realizer created successfully!',
            FAILED: 'Error creating Realizer',
          },
          UPDATE_REALIZER: {
            SUCCESSFUL: 'Realizer updated successfully!',
            FAILED: 'Error updating Realizer',
          },
          DELETE_REALIZER: {
            SUCCESSFUL: 'Realizer deleted successfully!',
            FAILED: 'Error deleting Realizer',
          },
          FETCH_REALIZERS: {
            FAILED: 'Error fetching Realizers',
          },
          FETCH_REALIZER: {
            FAILED: 'Error fetching Realizer',
          },
        },
      },
      GRAMMARS: {
        NAME: {
          REQUIRED: 'Name cannot be empty',
          REGEX: 'Name must consist only of letters and underscores',
          EXISTS: 'This grammar name already exists',
        },
        LENGTH: {
          REQUIRED: 'Length cannot be empty',
          REGEX: 'Length must consist only of numbers, dashes, commas or *',
        },
        FIELD: {
          REQUIRED: 'Field cannot be empty',
        },
        CREATE_GRAMMAR: {
          SUCCESSFUL: 'Grammar created successfully!',
          FAILED: 'Error creating Grammar',
        },
        UPDATE_GRAMMAR: {
          SUCCESSFUL: 'Grammar updated successfully!',
          FAILED: 'Error updating Grammar',
        },
        DELETE_GRAMMAR: {
          SUCCESSFUL: 'Grammar deleted successfully!',
          FAILED: 'Error deleting Grammar',
        },
        FETCH_GRAMMARS: {
          FAILED: 'Error fetching Grammars',
        },
        FETCH_GRAMMAR: {
          FAILED: 'Error fetching Grammar',
        },
      },
    },
    DRAWER: {
      NAME: {
        REQUIRED: 'Name cannot be empty',
        REGEX: 'Name must consist only of letters and underscores',
      },
      CONDITIONS: {
        CONDITION: {
          REQUIRED: 'Enter all the condition fields',
        },
      },
      TARGETS: {
        GENERAL: {
          PRIORITY: {
            REQUIRED: 'Priority cannot be empty',
            INVALID: 'Priority must be a positive number',
          },
        },
        TASK: {
          FIELD: {
            REQUIRED: 'Enter Field',
          },
          MESSAGE_FIELD: {
            REQUIRED: 'Enter Message ID',
          },
        },
      },
      ACTIONS: {
        MESSAGE_FIELD: {
          REQUIRED: 'Enter a Message ID',
          ONLY_ONE: 'Enter only one Message ID',
        },
        FIELDS: {
          REQUIRED: 'Enter one or more fields',
        },
        PROMPTS: {
          UTTERANCES: {
            FIELD_REQUIRED: 'Enter field',
            DEFAULT_RESPONSE_REQUIRED: 'Enter fallback utterance',
            REQUIRED: 'Enter utterance',
            PART_TEXT_REQUIRED: 'Enter value',
            PART_VALUE_REQUIRED: 'Enter value',
          },
          DEFAULT: {
            REQUIRED: 'Enter default utterance',
          },
          INITIAL_WAIT_MESSAGE: {
            REQUIRED: 'Enter initial wait message',
          },
          ADDITIONAL_WAIT_MESSAGE: {
            REQUIRED: 'Enter additional wait message',
          },
        },
        MAX_WAIT_TIME: {
          REQUIRED: 'Enter time',
          VALID:
            'Timeout should be greater than the sum of Play after and Play every',
        },
        INITIAL_WAIT_TIME: {
          REQUIRED: 'Enter time',
        },
        ADDITIONAL_WAIT_TIME: {
          REQUIRED: 'Enter time',
        },
        INPUT_FIELDS: {
          REQUIRED: 'Enter input fields',
        },
        OUTPUT_FIELDS: {
          REQUIRED: 'Enter output fields',
        },
        ORDER: {
          VALUE: 'Minimum 1',
          NUMBER: 'Enter number',
        },
      },
      TRACKERS: {
        EFFECTS: {
          TYPE: {
            REQUIRED: 'Select type of effect',
          },
          FIELD: {
            REQUIRED: 'Select effect field',
          },
          VALUE: {
            REQUIRED: 'Enter a value',
            MIN_VALUE: 'Enter a positive number',
          },
          STATUS: {
            REQUIRED: 'Select status',
          },
          EVENT: {
            REQUIRED: 'Select event type',
          },
          COUNTER: {
            REQUIRED: 'Select a parameter',
          },
          INTENT: {
            REQUIRED: 'Select an intent',
          },
          TARGET: {
            REQUIRED: 'Select a target',
          },
          REACTION: {
            REQUIRED: 'Select a reaction',
          },
          MESSAGE: {
            REQUIRED: 'Select a message ID',
          },
        },
      },
      REACTIONS: {
        EVENT: {
          REQUIRED: 'Select event type',
        },
      },
    },
    RESOURCES: {
      ACTION: {
        FIELDS: {
          REQUIRED: 'Enter at least one field',
        },
        MESSAGE_FIELDS: {
          REQUIRED: 'Enter a Message ID',
          ONLY_ONE: 'Enter only one Message ID',
        },
        NAME: {
          REQUIRED: "Enter action's name",
          REGEX: "Action's name must consist only of letters and underscores",
        },
      },
      REACTION: {
        NAME: {
          REQUIRED: "Enter reaction's name",
          REGEX: "Reaction's name must consist only of letters and underscores",
        },
      },
      TARGET: {
        NAME: {
          EXISTS: 'This target already exists',
          REQUIRED: "Enter target's name",
          REGEX: "Target's name must consist only of letters and underscores",
        },
      },
      TRACKER: {
        NAME: {
          EXISTS: 'This tracker already exists',
          REQUIRED: "Enter tracker's name",
          REGEX: "Tracker's name must consist only of letters and underscores",
        },
      },
    },
  },
  VERSION_CONTROL: {
    MODAL: {
      GIT_STATUS: {
        LOADING_MSG_COMMIT:
          'The system checks for issues between the current and the remote branch before proceeding to Commit & Push action. Please wait…',
        LOADING_MSG_FETCH:
          'The system checks for issues between the current and the remote branch before proceeding to Fetch action. Please wait…',
        ERROR_TITLE_FETCH: 'Fetch Required!',
        ERROR_BODY_FETCH:
          'Fetch the latest changes from the remote branch before proceeding to Commit & Push action',
        ERROR_TITLE_CONFLICTS: 'Conflicts Identified!',
        ERROR_BODY_CONFLICTS:
          'Some conflicts were identified between the current and the remote branch and must be resolved in order to continue.',
      },
      COMMIT: {
        GENERAL_TITLE: 'Commit & Push changes',
        LOADING_MSG:
          'Committing and pushing your changes to GitLab. Please wait...',
        ERROR_TITLE: 'Commit & Push failed',
        ERROR_BODY:
          'Could not commit changes to the GitLab server. Some errors occurred during the operation execution. Please try again.',
      },
      FETCH: {
        GENERAL_TITLE: 'Fetch changes...',
        LOADING_MSG: 'Fetching changes from GitLab. Please wait...',
        ERROR_TITLE: 'Fetching failed',
        ERROR_BODY:
          'Something went wrong while fetching your data to the GitLab server. Please come back and try again',
      },
      MERGE: {
        NOTICE_MSG:
          'After merge process, the current branch will be deleted automatically from the system repository',
      },
    },
    MERGE_MODAL: {
      MERGE_REQUEST_SUCCESS: 'Merge completed successfully!',
      CONFLICTS_IDENTIFIED: 'Conflicts Identified!',
      MERGE_REQUEST_FAILED: 'Merge Branch Failed!',
      UPDATE_SUCCESS: 'Update completed successfully!',
      UPDATE_PARENT: 'Update from Parent',
      UPDATE_PARENT_REQUIRED: 'Update from parent is required!',
      MERGE_REQUEST: 'Merge Branch',
      MERGING_BRANCH: 'Merging branch, please wait...',
      CHECKING_MERGE_PARENT:
        'Checking if your branch can be merged into the parent branch. Please wait...',
      MERGE_REQUEST_ERROR_MESSAGE:
        'Something went wrong during the merge process. Please try again.',
      UPDATE_PARENT_SUCCESS:
        "Update from parent completed successfully! To complete the 'Merge Branch' action, try merging your project again",
      UPDATE_PARENT_NEEDED:
        "This parent branch has new changes. The current branch needs to be updated before it can be merged. To proceed, press the 'Update From Parent' button to fetch the last changes.",
      PROJECT_DELETION_MESSAGE:
        'The project branch will be deleted automatically after the merge process. Remote GIT branch will remain available.',
      CONFLICTS_IDENTIFIED_MESSAGE:
        'Some conflicts were indentified between the current and the parent branch and must be resolved in order to continue',
      UPDATE_PARENT_ERROR: 'Update from Parent Failed!',
    },
    RESOLVE_CONFICTS: {
      MODALS: {
        LOADING_MODAL: {
          UPDATE_FROM_PARENT:
            'Fetch the latest changes from the parent branch.',
          FETCH_CHANGES: 'Fixing and fetching changes from the remote branch.',
        },
        SUCCESS_MODAL: {
          UPDATE_FROM_PARENT: {
            TITLE: 'Update completed successfully!',
            BODY:
              'Update from parent completed successfully! To complete the "Merge Branch" action, try merging your project again.',
          },
          FETCH_CHANGES: {
            TITLE: 'Conflicts resolved successfully!',
            BODY:
              'Conflicts resolved successfuly! Close this modal to navigate back to your project.',
          },
        },
      },
    },
    CREATE_BRANCH_MODAL: {
      NAME: {
        REQUIRED: 'Please type a name for the branch',
        MAX_LENGTH: 'Please use maximum 96 chars',
        REGEX:
          'Branch names must start with a letter and consist only of letters, digits, dashes or undescores',
        EXISTS: 'This branch already exists',
      },
    },
  },
};
